import { useChainId, useUserAddr } from '@/hooks/web3/useChain';
import { TradingMode } from '@/types/agent';
import React, { useEffect } from 'react';
import { useFetchAgentAddressFromChainQuery } from '../query';
import { useAgentStore } from '../store';

export function useCheckAgentStatus(chainId: number | undefined, userAddr: string | undefined): void {
  const { data: agentAddress, isFetched } = useFetchAgentAddressFromChainQuery(chainId, userAddr);
  const { setAgentAddress, setIsEnableAgentMode, setTradingMode } = useAgentStore();
  useEffect(() => {
    if (isFetched && userAddr) {
      if (agentAddress) {
        setAgentAddress(userAddr, agentAddress);
        setIsEnableAgentMode(userAddr, true);
        setTradingMode(TradingMode.Agent);
      } else {
        setAgentAddress(userAddr, null);
        setIsEnableAgentMode(userAddr, false);
        setTradingMode(TradingMode.Classic);
      }
    }
  }, [agentAddress, isFetched, userAddr, setAgentAddress, setIsEnableAgentMode, setTradingMode]);
}

function AgentGlobalEffect(): null {
  const chainId = useChainId();
  const userAddr = useUserAddr();
  useCheckAgentStatus(chainId, userAddr);

  return null;
}

export default React.memo(AgentGlobalEffect);
